export const API = 'API';
export const API_START = 'API_START';
export const API_SUCCESS = 'API_SUCCESS';
export const API_END = 'API_END';
export const API_ERROR = 'API_ERROR';
export const ACCESS_DENIED = 'ACCESS_DENIED';

export const API_LOADING = 'loading';
export const API_READY = 'ready';